import { toSafeBrandColor } from '@common/theme-layer/utils/brand-color'
import type { BrandTokens } from '@common/theme-layer/composables/useTheme'

import type { LocationBranding } from '../types/location'

/**
 * Maps clientportal portal branding to the partial BrandTokens accepted by
 * `useTheme().setBrandTokens`.
 *
 * - `brandColor1` → `primary`: drives the primary scale (50-900), the HighRise
 *   `--primary-*` bridge, and `--cp-text-on-primary`.
 * - `brandColor2` → `secondary`: drives the secondary scale (`--cp-secondary-*`) +
 *   `--cp-text-on-secondary`, and writes `--cp-brand-secondary` — the same var the
 *   legacy `applyBranding` path also sets from `brandColor2`, so they agree.
 *
 * The remaining tokens are omitted so `resolveBrandTokens` fills them from defaults.
 * Each colour is mapped independently — a blank/absent value is simply skipped.
 */
export function mapPortalBrandingToTokens(branding: Pick<LocationBranding, 'brandColor1' | 'brandColor2'>): Partial<BrandTokens> {
  const tokens: Partial<BrandTokens> = {}
  const primary = toSafeBrandColor(branding.brandColor1)
  const secondary = toSafeBrandColor(branding.brandColor2)

  if (primary) {
    tokens.primary = primary
  }

  if (secondary) {
    tokens.secondary = secondary
  }

  return tokens
}
